const REFERRER_KEY = 'referrer';
const REFERRER_TTL = 30 * 24 * 60 * 60 * 1000;

export function getReferrer() {
  const saved = JSON.parse(localStorage.getItem(REFERRER_KEY) || 'null');
  if (saved && Date.now() - saved.savedAt < REFERRER_TTL) {
    return saved.code;
  }
  clearReferrer();
  return null;
}

export function saveReferrer(code) {
  if (!getReferrer()) {
    localStorage.setItem(
      REFERRER_KEY,
      JSON.stringify({ code, savedAt: Date.now() }),
    );
  }
}

export function clearReferrer() {
  localStorage.removeItem(REFERRER_KEY);
}
